<ng-template #template let-row="row" let-index="rowIndex">
  <div class="project-responsible-client-cell">
    @if (row?.basicDataBox?.responsibleContact) {
      <contact-name
        [contact]="row?.basicDataBox?.responsibleContact"
        [placement]="index > 1 ? 'top' : 'bottom'"
        [defaultStyling]="true"
      />
    } @else {
      <span class="pl-1">-</span>
    }
  </div>
</ng-template>
